// extracted by mini-css-extract-plugin
export default {"charts":"Chart_charts__gpLgn","card":"Chart_card__GiLvq"};